<template>
  <router-link :to="to" class="menu-link">
    <span v-html="getSVG(icon)" />
    <div class="menu-link-text">{{ title }}</div>
  </router-link>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: [
    "title",
    "icon",
    "to",
  ],
}
</script>